import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const SKIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="SK" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#3D58DB"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#F7FCFF"
          fillRule="evenodd"
          d="M0 0v4h16V0H0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#E31D1C"
          fillRule="evenodd"
          d="M0 8v4h16V8H0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#E31D1C"
          stroke="#fff"
          strokeWidth={0.5}
          d="m8.027 2.765.023.224h.001v.008l.003.021.008.083.03.303c.022.254.052.603.077.982.05.75.086 1.652.015 2.168-.142 1.022-.756 2.677-2.593 3.498l-.1.045-.101-.044c-1.934-.835-2.435-2.679-2.544-3.5-.056-.42-.034-1.322-.002-2.092a64.866 64.866 0 0 1 .071-1.343l.006-.088.001-.024L2.923 3V3l.016-.234h5.088Z"
        />
        <Mask
          id="c"
          width={7}
          height={9}
          x={2}
          y={2}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: "luminance",
          }}
        >
          <Path
            fill="#fff"
            stroke="#fff"
            strokeWidth={0.5}
            d="m8.027 2.765.023.224h.001v.008l.003.021.008.083.03.303c.022.254.052.603.077.982.05.75.086 1.652.015 2.168-.142 1.022-.756 2.677-2.593 3.498l-.1.045-.101-.044c-1.934-.835-2.435-2.679-2.544-3.5-.056-.42-.034-1.322-.002-2.092a64.866 64.866 0 0 1 .071-1.343l.006-.088.001-.024L2.923 3V3l.016-.234h5.088Z"
          />
        </Mask>
        <G fillRule="evenodd" clipRule="evenodd" mask="url(#c)">
          <Path
            fill="#F7FCFF"
            d="M5.128 3.295s.104.157.15.398c.046.24.054.662.054.662l-.98-.12v.742l1.002-.128-.016.705s-.3.031-.546 0a7.716 7.716 0 0 1-.73-.161v.85s.492-.157.73-.193c.238-.036.546 0 .546 0v1.044h.406V6.05s.445-.039.71.003c.265.042.516.19.516.19v-.85s-.255.127-.495.159c-.24.031-.73.002-.73.002l.015-.705s.333-.034.52-.009c.186.026.42.137.42.137v-.743s-.228.124-.407.147c-.179.022-.554-.026-.554-.026s.006-.435.045-.647c.038-.212.147-.413.147-.413h-.803Z"
          />
          <Path
            fill="#2E42A5"
            d="M3.449 8.123s.22-.472.577-.562c.357-.09.732.281.732.281s.23-.748.787-.748c.558 0 .754.748.754.748s.238-.28.58-.28c.343 0 .66.56.66.56S6.517 9.98 5.494 9.98 3.449 8.123 3.449 8.123Z"
          />
        </G>
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
